import * as constants from '../config/constants';

const getCSS = () => {
  let overrideCSS = null;
  if (window.location.host === constants.MAIN_SITE_HOST) {
    overrideCSS = require('./main.css');  // eslint-disable-line
  }
  if (window.location.host === constants.RAJKOT_SITE_HOST) {
    overrideCSS = require('./main.css');  // eslint-disable-line
  }
  if (window.location.host === constants.AMD_SITE_HOST) {
    overrideCSS = require('./main.css');  // eslint-disable-line
  }
  if (window.location.host === constants.SURAT_SITE_HOST) {
    overrideCSS = require('./main.css');  // eslint-disable-line
  }
  if (window.location.host === constants.LOHANA_SITE_HOST) {
    overrideCSS = require('./theme2.css');  // eslint-disable-line
  }
  if (window.location.host === constants.DIVORCEE_SITE_HOST) {
    overrideCSS = require('./main.css');  // eslint-disable-line
  }
  if (window.location.host === constants.NRI_SITE_HOST) {
    overrideCSS = require('./theme3.css');  // eslint-disable-line
  }
  if (window.location.host === constants.JAIN_SITE_HOST) {
    overrideCSS = require('./theme2.css');  // eslint-disable-line
  }
  if (window.location.host === constants.KOLKATA_SITE_HOST) {
    overrideCSS = require('./theme2.css');  // eslint-disable-line
  }
  if (window.location.host === constants.GORMAHARAJ_HOST) {
    overrideCSS = require('./theme3.css');  // eslint-disable-line
  }
  if (window.location.host === constants.SHAADIYOG_HOST) {
    overrideCSS = require('./theme2.css');  // eslint-disable-line
  }
  return overrideCSS;
};

const cssClasses = getCSS();

export default cssClasses;



// WEBPACK FOOTER //
// ./src/css/getCSS.js